import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import PageHeader from '../../../shared/blocks/page-header/page-header';
import PasswordForm from '../../../shared/forms/password-form';
import useUpdatePassword from '../../../../utilities/hooks/useUpdatePassword';

const EditPassword = () => {
  const navigate = useNavigate();
  const { update: updatePassword, isLoading } = useUpdatePassword();

  const handleBack = useCallback(() => {
    navigate('/profile', { state: { passwordResetSuccess: true } });
  }, [navigate]);

  const handleSubmit = useCallback((formValues) => {
    updatePassword(formValues, {
      onSuccess: () => {
        navigate('/profile', { state: { passwordResetSuccess: true } });
      },
    });
  }, [navigate, updatePassword]);

  return (
    <div className="edit-password-page">
      <PageHeader title="Edit password" />

      <PasswordForm
        onCancel={handleBack}
        onSubmit={handleSubmit}
        submitting={isLoading}
      />

    </div>
  );
};

export default EditPassword;
